// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__24o6L","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1zKKR","obliqueLine":"membershipbadge_obliqueLine__gptUj"};